// removed by extract-text-webpack-plugin
module.exports = {"block":"Main__block-umK9y"};